<template>
  <div class="more-resources margin-general">
    <div class="text-content">
      <h2 v-if="titleH2">{{ $t(titleH2) }}</h2>
      <h3 v-if="titleH3">{{ $t(titleH3) }}</h3>
      <p class="desc" v-if="description">{{ $t(description) }}</p>
    </div>
    <ClientOnly>
      <swiper
      :spaceBetween="10"
      :slidesPerView="1.4"
      :slidesPerGroup="1"
      :loop="true"
      :navigation="true"
      :modules="modules"
      class="swiper"
      :breakpoints="{
        '1000': {
          slidesPerView: 2,
          spaceBetween: 30,
          slidesPerGroup: 1,
        },
        '426': {
          slidesPerView: 1.4,
          spaceBetween: 30,
          slidesPerGroup: 1,
        },
        '376': {
          slidesPerView: 1.2,
          spaceBetween: 10,
          slidesPerGroup: 1,
        },
        '0': {
          slidesPerView: 1.1,
          spaceBetween: 10,
          slidesPerGroup: 1,
        },
      }"
    >
      <swiper-slide
        v-for="row in cards"
        :key="row.title"
        class="content-slide"
        :class="padding"
      >
        <img
          :src="row.imgSrc"
          :alt="row.alt"
          class="img-card"
          v-if="row.imgSrc"
          :width="row.imgWidth || 300"
          :height="row.imgHeight || 200"
          format="avif,webp"
          quality="85"
          loading="lazy"
          decoding="async"
        />
        <div class="icon" v-if="row.icon">
          <span class="material-symbols-outlined" translate="no">{{ row.icon }}</span>
        </div>
        <div class="text">
          <h3 class="title-card subtitle-4">{{ $t(row.title) }}</h3>
          <p class="desc body-4">{{ $t(row.desc) }}</p>
        </div>
        <NuxtLink
          :to="localPath(row.link)"
          v-if="row.link"
          class="second-button-small"
          role="button"
        >
          {{ $t(row.textLink) }}
        </NuxtLink>
      </swiper-slide>
      </swiper>
    </ClientOnly>

    <div class="none-slide">
      <div v-for="row in cards" :key="row.title" class="content-slide">
        <img
          :src="row.imgSrc" 
          :alt="row.alt || ''" 
          class="img-card" 
          v-if="row.imgSrc"
          :width="row.imgWidth || 300"
          :height="row.imgHeight || 200"
          loading="lazy"
          decoding="async"
        />
        <div class="icon" v-if="row.icon">
          <span class="material-symbols-outlined" translate="no">{{ row.icon }}</span>
        </div>
        <div class="text">
          <h3 class="title-card subtitle-4">{{ $t(row.title) }}</h3>
          <p class="desc body-5">{{ $t(row.desc) }}</p>
        </div>
        <NuxtLink :to="localPath(row.link)" v-if="row.link" class="second-button-small"
          >
            {{ $t(row.textLink) }}
          </NuxtLink
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

const localPath = useLocalePath();
const props = defineProps({
  titleH2: String,
  titleH3: String,
  description: String,
  cards: Object,
  icon: String,
  img: String,
  padding: {
    type: String,
    default: "padding-img",
  },
});

const modules = [Autoplay, Pagination, Navigation];

</script>